//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Eos from 'eosjs'
import ecc from 'eosjs-ecc';
import apple from '../../static/images/pic_apple.png';
import orange from '../../static/images/pic_orange.png';
import mongo from '../../static/images/pic_mongo.png';
import watermelon from '../../static/images/pic_watermelon.png';
import star from '../../static/images/pic_star.png';
import seven from '../../static/images/pic_seven.png';
import bar from '../../static/images/pic_bar.png';
	
			let card = 1;
  			var cardArr=[],cardArr1=[];
  			cardArr=initValue();
  			cardArr1=initValue();
  			function initValue(){
  				let card = 1;
  				let  cardArr=[];
  				for(let i=1;i<=52;i++){
  				let num;
  				if(i%13){
  					if(i<=13){
  						num='0'+card.toString(16);
  					}
  					if(i>13&& i<=26){
  						num='1'+card.toString(16);
  					}
  					if(i>26&& i<=39){
  						num='2'+card.toString(16);
  					}
  					if(i>39&& i<=52){
  						num='3'+card.toString(16);
  					}
  				}else{
  					let num1=13;
  					if(i<=13){
  						num='0'+num1.toString(16);
  					}
  					if(i>13&& i<=26){
  						num='1'+num1.toString(16);
  					}
  					if(i>26&& i<=39){
  						num='2'+num1.toString(16);
  					}
  					if(i>39&& i<=52){
  						num='3'+num1.toString(16);
  					}
  					card=0;
  				}
  				card++;
  				cardArr.push(num);
  				}
  				return cardArr;
  			}
  			
  			for(let i=1;i<=52;i++){
  				let num;
  				if(i%13){
  					if(i<=13){
  						num='0'+card.toString(16);
  					}
  					if(i>13&& i<=26){
  						num='1'+card.toString(16);
  					}
  					if(i>26&& i<=39){
  						num='2'+card.toString(16);
  					}
  					if(i>39&& i<=52){
  						num='3'+card.toString(16);
  					}
  				}else{
  					let num1=13;
  					if(i<=13){
  						num='0'+num1.toString(16);
  					}
  					if(i>13&& i<=26){
  						num='1'+num1.toString(16);
  					}
  					if(i>26&& i<=39){
  						num='2'+num1.toString(16);
  					}
  					if(i>39&& i<=52){
  						num='3'+num1.toString(16);
  					}
  					card=0;
  				}
  				card++;
  				cardArr.push(num);
  			}
  			

export default {
  name: 'verification',
  data () {
    return {
     		verData:{},
     		result:false,
     		bufDate:[
     			[],[],[],[],[]
     		],
     		fruit:{
     			1:seven,
     			2:apple,
     			3:orange,
     			4:bar,
     			5:mongo,
     			6:orange,
     			7:apple,
     			8:star,
     			9:apple,
     			10:mongo,
     			11:watermelon,
     			12:apple,
     			13:seven,
     			14:apple,
     			15:orange,
     			16:watermelon,
     			17:mongo,
     			18:orange,
     			19:apple,
     			20:star,
     			21:apple,
     			22:mongo,
     			23:watermelon,
     			24:orange
     		},
     		publicKey:"",
   			sha256:'',
   			lastSixNum:'',
   			luckNum:'',
   			timeZone:'',
   			isNew:false,
   			seed:'',
   			signature:'',
   			pkey	:'',
   			Bufresult:'',
   			BufresultBox:false,
   			randromArr:[]
    }
  },
  created(){
  			this.timeZone = new Date().getTimezoneOffset() / 60;
  			
			if(this.$route.query && this.$route.query.data){
				this.verData=JSON.parse(this.$route.query.data);
				for(let item in this.verData){
					let obj ={
						name : item,
						value: this.verData[item]
					}
					if(item.indexOf('0')>-1){
						if(item.indexOf('Seed')>-1){
							obj["name"]="庄家随机种子(Banker Seed)";
						}else if(item.indexOf('sign')>-1){
							obj["name"]="庄家签名种子(Banker Signature)";
						}else{
							obj["name"]="庄家牌型(Card type Banker)";
						}
						this.bufDate[0].push(obj)
					}
					if(item.indexOf('1')>-1){
						if(item.indexOf('Seed')>-1){
							obj["name"]="闲一随机种子(Player 1 Seed)";
						}else if(item.indexOf('sign')>-1){
							obj["name"]="闲一签名种子(Player 1 Signature)";
						}else{
							obj["name"]="闲一牌型(Card type Player 1)";
						}
						this.bufDate[1].push(obj)
					}
					if(item.indexOf('2')>-1){
						if(item.indexOf('Seed')>-1){
							obj["name"]="闲二随机种子(Player 2 Seed)";
						}else if(item.indexOf('sign')>-1){
							obj["name"]="闲二签名种子(Player 2 Signature)";
						}else{
							obj["name"]="闲二牌型(Card type Player 2)";
						}
						this.bufDate[2].push(obj)
					}
					if(item.indexOf('3')>-1){
						if(item.indexOf('Seed')>-1){
							obj["name"]="闲三随机种子(Player 3 Seed)";
						}else if(item.indexOf('sign')>-1){
							obj["name"]="闲三签名种子(Player 3 Signature)";
						}else{
							obj["name"]="闲三牌型(Card type Player 3)";
						}
						this.bufDate[3].push(obj)
					}
					if(item.indexOf('4')>-1){
						if(item.indexOf('Seed')>-1){
							obj["name"]="闲四随机种子(Player 4 Seed)";
						}else if(item.indexOf('sign')>-1){
							obj["name"]="闲四签名种子(Player 4 Signature)";
						}else{
							obj["name"]="闲四牌型(Card type Player 4)";
						}
						this.bufDate[4].push(obj)
					}
				}
				
			
				if(!this.verData.card0){
					 var reg = /:/g;
					 var arr  = this.verData.combine_seed.match(reg);
					 
					if(arr.length==4){
						this.isNew=1;
					}else if(arr.length==5){
						this.isNew=2;
					}else{
						this.isNew=0;
					}
				}
			}
			
			
  },
  filters:{
			cardType:function(item){
				let that=this;
				let num = cardArr[item];
				let type = num.split('')[0];
				cardArr.splice(item,1)
				switch(type){
					case "0":
						return '../../../../static/images/piece.png';
					case "1":
						return '../../../../static/images/blossom.png';
					case "2":
						return '../../../../static/images/redPeach.png';	
					case "3":
						return '../../../../static/images/Spades.png';
					default:
						return '';
				}
			},
			cardVal:function(item){
				let num = cardArr1[item];
				let type = num.split('')[1];
				cardArr1.splice(item,1);
				switch(type){
					case "a":
						return '10';
					case "b":
						return 'J';
					case "c":
						return 'Q';	
					case "d":
						return 'K';
					default:
						return type;
				}
			},
			nameStr:function(val){
				let num =val-0;
				switch(num){
					case 0:
						return "庄家随机数(Random number of Banker)";
					case 1:
						return "闲一随机数(Random number of play 1)";
					case 2:
						return "闲二随机数(Random number of play 2)";
					case 3:
						return "闲三随机数(Random number of play 3)";
					case 4:
						return "闲四随机数(Random number of play 4)";
					defaults:
						return "";
				}
			},
			cardStr:function(val){
				let num =val-0;
				switch(num){
					case 0:
						return "庄家牌型(Card type of Banker)";
					case 1:
						return "闲一牌型(Card type of play 1)";
					case 2:
						return "闲二牌型(Card type of play 2)";
					case 3:
						return "闲三牌型(Card type of play 3)";
					case 4:
						return "闲四牌型(Card type of play 4)";
					defaults:
						return "";
				}
			}
		},
  methods: {
  	formatDate(t) {
				let that = this;
				t = t.replace(/T/g, " ")

				var u = navigator.userAgent,
					app = navigator.appVersion;
				var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
				var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if(isAndroid) {
					t = t
				}
				if(isIOS) {　　　　
					t = t.replace(/\-/g, "/")
				}

				let LocalStampTime = new Date(t).getTime() - that.timeZone * 60 * 60 * 1000;

				let YY = new Date(LocalStampTime).getFullYear();
				let MM = new Date(LocalStampTime).getMonth() + 1;
				let DD = new Date(LocalStampTime).getDate();
				let hh = new Date(LocalStampTime).getHours();
				let mm = new Date(LocalStampTime).getMinutes();
				let ss = new Date(LocalStampTime).getSeconds();

				MM = MM < 10 ? "0" + MM : MM;
				DD = DD < 10 ? "0" + DD : DD;
				hh = hh < 10 ? "0" + hh : hh;
				mm = mm < 10 ? "0" + mm : mm;
				ss = ss < 10 ? "0" + ss : ss;

				return YY + "-" + MM + "-" + DD + " " + hh + ":" + mm + ":" + ss;

			},
  	verify(){
  			let that=this;
  			this.sha256= ecc.sha256(this.verData.sig);
  			this.lastSixNum=this.sha256.substr(this.sha256.length-6,6);
  			if(this.verData.lucky_fruit){
  				this.luckNum=parseInt(this.lastSixNum,16)%24+1;
  			}else{
  				this.luckNum=parseInt(this.lastSixNum,16)%100+1;
  			}
	  	  this.result=ecc.verify(this.verData.sig,this.verData.combine_seed,this.verData.publicKey);
  	},
  	Bufverify(){
  		let that=this;
  		if(this.bufDate[0][0]){
  			cardArr=initValue();
  			cardArr1=initValue();
  			let num =52;
  			that.randromArr=[];
  			this.bufDate.forEach(function(n){
  				//item.indexOf('sign')>-1
  				if(n[2]["name"].indexOf("Signature")>-1){
  					let number =that.getRandom(n[2]["value"],num);
  					that.randromArr.push(number);
  					num=num-5;
  				}
  			})
  		}
  		this.BufresultBox=true;
//		 if(this.verData){
//	  		  this.BufresultBox=true;
//		  	  this.Bufresult=ecc.verify(this.signature,this.seed,this.pkey);
//		 }
  	},
  	getRandom(sign,num){
  		let obj = [];
  		let number=(num-0);
  		let that=this;
  		this.sha256= ecc.sha256(sign);
  		for(let i=0;i<5;i++){
  			let lastSix = that.sha256.substr(that.sha256.length-(6*(i+1)),6);
 			let num1=parseInt(lastSix,16)%number;
 			obj.push(num1)
 			number--
  		}
  		return obj;
  	},
  	formatTime(unixTimestamp) {
				unixTimestamp = new Date(unixTimestamp * 1000);
				let commonTime = unixTimestamp.toLocaleString();
				if(commonTime.indexOf("上午","")>-1){
					return commonTime.replace("上午",'');
				}
				return commonTime.replace("下午",'pm');
	  		 },
  }
}



// WEBPACK FOOTER //
// ./src/components/verification.vue